import { mapState, } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    resultList () {
      return document.getElementById('results-section')
    },
    searchInput () {
      return document.getElementById('search')
    },
    searchForm () {
      return document.getElementById('search-form')
    },
    ...mapState('search', [ 'expertMode', ]),
  },
  methods: {
    goToSearch () {
      this.scrollTo(this.searchForm.offsetTop - (window.innerWidth > 1024 ? 50 : 0))
      if (!this.expertMode) this.searchInput.focus()
    },
    goToSearchPage (hash = 'search-form') {
      // this.$route.name === 'SearchPage' || this.$route.name === 'Search'
      //   ? this.goToSearch()
      //   : this.$router.push({name: 'SearchPage', hash})
    },
    scrollToResults () {
      this.scrollTo(this.resultList.offsetTop - (window.innerWidth > 1024 ? 25 : 0))
    },
    scrollTo (to) {
      if (typeof window === 'undefined') return
      window.scrollTo(0, to)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/go-to-search.js